import styled from 'styled-components';
import {
  Preview as MaterialPreview,
  TextBulletListSquareWarning as MaterialTextBulletListSquareWarning
} from '../../../../../styles/icons';
import {
  MuiPickersUtilsProvider as MaterialMuiPickersUtilsProvider,
  KeyboardDatePicker as MaterialKeyboardDatePicker,
} from '@material-ui/pickers';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Preview = styled(MaterialPreview)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;

export const TextBulletListSquareWarning = styled(MaterialTextBulletListSquareWarning)`
  width: 25px;
  height: 25px;
  fill: var(--secondary);
`;

export const SelectContainer = styled.div`
  width: 500px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  & > * {
    margin: auto !important;
  }
`;
export const MuiPickersUtilsProvider = styled(MaterialMuiPickersUtilsProvider)`
  padding: 0 !important;
`;

export const KeyboardDatePicker = styled(MaterialKeyboardDatePicker)`
  width: 40%;
  padding: 0 !important;
`;
